<template>
  <div class="bggray" @click="optionActive = false">
    <app-header />
    <div class="orderWrap">
      <div class="orderNav">
        <span class="cur">确认购买信息</span>
        <span class="cur">选择支付方式</span>
        <span>购买成功开通权限</span>
      </div>
      <div class="mod orderInfo">
        <h3 class="title">订单详情</h3>
        <ul class="column4">
          <li>
            <div>产品名称</div>
            <div>充值金额</div>
            <div>充值用途</div>
            <div>余额<span class="icon" @click="isTipsPop = true">?</span></div>
          </li>
          <li>
            <div>
              <p>账户充值</p>
            </div>
            <div>
              <input v-model="rechargeMoney" type="text" class="rechargeInput" oninput="value=value.replace(/[^\d^\.]+/g, '').replace(/^0+(\d)/, '$1').replace(/^\./, '0.').match(/^\d*(\.?\d{0,2})/g)">
            </div>
            <div>{{orderInfo.productName}}</div>
            <div>￥{{amount}}元<span class="down" :class="{up: isHistory}" @click="isHistory = !isHistory "></span></div>
          </li>
        </ul>
        <div class="recharge-history" v-show="isHistory">
          <h3>历史充值记录</h3>
          <ul>
            <li>
              <span>订单编号</span>
              <span>充值用途</span>
              <span>支付方式</span>
              <span>充值时间</span>
              <span>充值金额</span>
            </li>
            <template v-if="rechargeHistory.length > 0">
              <li v-for="item in rechargeHistory" :key="item.serialId">
                <span>{{item.paymentId}}</span>
                <span>{{item.productName}}</span>
                <span>{{item.payModeString}}</span>
                <span>{{item.payDt | dateFormat("yyyy-MM-dd")}}</span>
                <span>¥ {{item.amount}}</span>
              </li>
              <li>
                <span>余额</span>
                <span>¥ {{amount}}</span>
              </li>
            </template>
            <li class="empty" v-else>暂无记录</li>
          </ul>
        </div>
      </div>
      <div class="mod pr">
        <h3 class="title">支付方式</h3>
        <ul class="dispatch-list">
          <li>账号：{{userName}}</li>
          <li>账户余额：￥{{amount}}元<span class="icon" @click="isRecordPop = true">?</span></li>
        </ul>
        <div class="nav-pay clearfix">
          <span @click="selectPayModeOuter(11,0)" :class="{cur : payIndex == 0}">支付宝/微信支付</span>
        </div>
        <div class="pay-con">
          <div class="bank-list" v-show="payIndex === 0">
            <span
              v-for="(item, index) in rechargePay"
              :key="item.id"
              :class="{cur: index === bankIndex}"
              @click="selectPayModeInner(item.payMode, index)"
            >
              <img :src="require('@/assets/images/bank/' + item.imgName)" />
            </span>
          </div>
        </div>
        <p class="pay-info">
          如遇到支付问题，可随时拨打
          <em>021-20219999</em>，客服将第一时间帮你解决
        </p>
        <a class="btn-normal" @click="orderPay">确认订单</a>
      </div>
    </div>
    <div class="pop-tips" v-show="isTipsPop">
      <h2>系统提示：</h2>
      <div class="con">
        <p>1. 大额充值支持支付宝、银联在线、微信支付。</p>
        <p>2. 充值时，请按照产品售价进行充值，不要多充。</p>
        <p>3. 充值完成后请在10个工作日内下单购买产品。</p>
        <p>4. 10个工作日末下单的将进入退款流程。</p>
        <p>咨询电话：021-20219997</p>
        <p>销售热线：021-20219999</p>
      </div>
      <span class="close" @click="isTipsPop = false">x</span>
    </div>
    <popRecord :isPop="isRecordPop" :recordList="recordList" @close="popClose"/>
    <app-footer />
  </div>
</template>
<script>
import AppHeader from "@/components/common/AppHeader.vue";
import AppFooter from "@/components/common/AppFooter.vue";
import payData from "@/assets/paybank.json";
import PopRecord from '../../components/order/PopRecord.vue';
export default {
  data() {
    return {
      orderId: this.$route.params.orderId,
      payMoney: "",
      payMode: 11, //默认支付宝
      bankCode: "",
      orderInfo: {},
      payActive: false,
      payIndex: 0,
      bankIndex: 0,
      selectedText: "更多",
      rechargePay: payData.rechargePay,
      unionPayB2C: payData.unionPayB2C,
      unionPayOnline: payData.unionPayOnline,
      bill99Pay: payData.bill99Pay,
      transPay: payData.transPay,
      orderPayAble: true,
      productId: '',
      rechargeInfo: {},
      userName: "",
      amount: 0,
      rechargeMoney: '',
      isTipsPop: false,
      isHistory: false,
      isRecordPop: false,
      rechargeHistory: [],
      recordList: []
    };
  },
  created() {
    this.getData();
    this.getUserAcountDate();
    this.getUserhisttory()
    this.getRecord()
  },
  methods: {
    getData() {
      this.$get("/order/pay?id=" + this.orderId)
        .then(response => {
          if (response.code === 0) {
            this.orderInfo = response.data;
            this.productId = response.data.productId

            if (this.orderInfo.paidMoney > 0) {
              this.selectPayModeOuter(26,2);
            }
          } else if (!(response.code === 100 || response.code === 9999)) {
            this.$global.alertAndGoHistory(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertAndGoHistory("网络异常，请稍后重试。");
        });
    },
    getUserAcountDate(){
      this.$get("/recharge/detail")
      .then(response => {
          if (response.code === 0) {
            this.rechargeInfo = response.data;
            this.userName = response.data.userName;
            this.amount = response.data.amount
          } else if (!(response.code === 100 || response.code === 9999)) {
            this.$global.alertAndGoHistory(response.msg);
          }
        })
        .catch(err =>{
          this.$global.alertAndGoHistory("网络异常，请稍后重试。");
        });
    },
    getUserhisttory(){
      let params = {
        status: 1
      }
      this.$get("recharge/history", params)
      .then(response => {
          if (response.code === 0) {
            this.rechargeHistory = response.data;
          } else if (!(response.code === 100 || response.code === 9999)) {
            this.$global.alertAndGoHistory(response.msg);
          }
        })
        .catch(err =>{
          this.$global.alertAndGoHistory("网络异常，请稍后重试。");
        });
    },
    getRecord(){
      this.$get("recharge/history")
      .then(response => {
          if (response.code === 0) {
            this.recordList = response.data;
          } else if (!(response.code === 100 || response.code === 9999)) {
            this.$global.alertAndGoHistory(response.msg);
          }
        })
        .catch(err =>{
          this.$global.alertAndGoHistory("网络异常，请稍后重试。");
        });
    },
    popClose (val) {
      this.isRecordPop = val
    },
    selectPayModeOuter(payMode, payIndex) {
      if (payMode == 27 || payMode == 7) {
        this.bankCode = "ABC";
      }
      if (payMode == 3) {
        this.bankCode = "ICBC";
      }
      this.payActive = false;
      this.payMode = payMode;
      this.payIndex = payIndex;
      this.bankIndex = 0;
    },
    selectBank(bankCode, bankIndex) {
      this.bankCode = bankCode;
      this.bankIndex = bankIndex;
    },
    selectPayModeInner(payMode, bankIndex) {
      if (payMode == 26) {
        this.payMoney = '';
      }
      this.payMode = payMode;
      this.bankIndex = bankIndex;
    },
    selectMore(e, payMode, payIndex) {
      this.payActive = false;
      this.selectedText = e.target.innerText;
      this.selectPayModeOuter(payMode, payIndex);
    },
    orderPay() {
      if (!this.payMode) {
        this.$alert("请选择您的支付方式", "提示", {
          confirmButtonText: "确定"
        });
        return false;
      }
      if(!this.rechargeMoney){
        this.$alert("请输入充值金额")
        return false;
      }
      if(this.payMode===23){
        // 跳转二维码支付页面
        this.$router.push("/pay/rechargeqrcode/" + this.orderId + "/" + this.rechargeMoney);
        return false; 
      }
      var params = {
        id: this.orderId,
        payMode: this.payMode,
        payMoney: this.rechargeMoney,
        productId: this.productId
      };
      this.orderPayAble = false;
      this.$get("/pay/recharge", params)
        .then(response => {
          if (response.code === 0) {
            window.location.href = response.data;
          } else if (response.code != 100) {
            this.$global.alert(response.msg);
          }
          this.orderPayAble = true;
        })
        .catch(err => {
          this.orderPayAble = true;
          this.$global.alertError();
        });
    },
  },
  components: {
    AppHeader,
    AppFooter,
    PopRecord
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/scss/order.scss";
.orderInfo>ul>li:nth-child(2)>div .giftName{width: 250px;}
.icon-checked {
  background-image: url(~@/assets/images/icon/right.png);
  background-size: 14px auto;
  width: 20px;
  height: 20px;
  margin-right: 8px;
  background-color: #166eff;
  cursor: pointer;
}
.orderInfo {
  .column4 {
    li {
      > div {
        &:first-child {
          width: 280px;
        }
        &:nth-child(2) {
          width: 230px;
        }
        &:nth-child(3) {
          width: 270px;
        }
        &:nth-child(4) {
          width: 150px;
          text-align: right;
        }
        .icon{
          border: 1px solid #666666;
          width: 18px;
          height: 18px;
          font-size: 15px;
          color: #666666;
          text-align: center;
          line-height: 18px;
          display: inline-block;
          margin-left: 10px;
          border-radius: 50%;
          cursor: pointer;
        }
        .down{
          border: 1px solid #666666;
          width: 18px;
          height: 18px;
          position: relative;
          display: inline-block;
          margin-left: 10px;
          border-radius: 50%;
          cursor: pointer;
          vertical-align: middle;
          &:after{
            content: '';
            display: block;
            width: 8px;
            height: 8px;
            border-top: 1px solid #666666;
            border-right: 1px solid #666666;
            transform: rotate(135deg);
            position: absolute;
            left: 5px;
            top: 3px;
          }
          &.up{
            &:after{
              transform: rotate(-45deg);
              top: 7px;
            }
          }
        }
      }
      &:nth-child(2) {
        > div {
          &:last-child {
            @include fc(16px, #222);
          }
        }
      }
    }
  }
}
.dispatch-list {
  overflow: hidden;
  margin-bottom: 15px;
  li {
    @include fc(16px, #666);
    margin-bottom: 12px;
    span{
      color: #000000;
    }
    &:nth-child(1){
      float: left;
      width: 22%;
    }
    .icon{
      border: 1px solid #666666;
      width: 18px;
      height: 18px;
      font-size: 15px;
      color: #666666;
      text-align: center;
      line-height: 18px;
      display: inline-block;
      margin-left: 10px;
      border-radius: 50%;
      cursor: pointer;
    }
  }
}
.nav-pay {
  span {
    padding: 0 16px;
    @include line-height(40px);
    border: 1px solid #e5e5e5;
    border-right: 0;
    background: #fff;
    float: left;
    box-sizing: border-box;
    cursor: pointer;
    &.cur {
      background: #fbfbfb;
      border-top: 2px solid #166fff;
      border-bottom: 1px solid #fbfbfb;
    }
  }
  .select {
    float: left;
    position: relative;
    .selected {
      position: relative;
      .icon-selectBtn {
        border-left: 0;
        height: 40px;
      }
      span {
        width: 120px;
        border-right: 1px solid #e5e5e5;
      }
    }
    .optionList {
      width: 118px;
      top: 40px;
      li {
        text-indent: 0;
        text-align: center;
      }
    }
  }
}
.pay-con {
  margin: -1px 0 70px 0;
  width: 100%;
  box-sizing: border-box;
  background: rgba(216, 216, 216, 0.1);
  padding: 30px 15px;
  border: 1px solid #e5e5e5;
  > .bank-list {
    &:first-child {
      img {
        height: 58px;
      }
    }
  }
  .bank-list {
    & > span {
      background: #ffffff;
      border: 1px solid #d6d6d6;
      border-radius: 1.96px;
      @include wh(167px, 60px);
      text-align: center;
      display: inline-block;
      margin: 0 15px 15px 0;
      line-height: 60px;
      &:nth-child(5n) {
        margin-right: 0;
      }
      cursor: pointer;
      img {
        vertical-align: middle;
      }
      &.cur {
        border: 1px solid #166fff;
        position: relative;
        &:after {
          content: "";
          display: inline-block;
          @extend .icon-checked;
          background-repeat: no-repeat;
          background-position: center center;
          position: absolute;
          right: -1px;
          bottom: -1px;
          margin-right: 0;
        }
      }
    }
  }
  .unionPayOnline {
    .bank-list {
      float: left;
    }
    .unionPayOnline-r {
      margin-left: 400px;
      border-left: 1px solid #dbdbdb;
      padding: 0px 30px 5px;
      p {
        @include fc(14px, #666);
        line-height: 22px;
        margin-bottom: 10px;
      }
      input {
        border: 1px solid #dbdbdb;
        line-height: 24px;
        width: 110px;
        margin-right: 5px;
        padding-left: 10px;
      }
    }
  }
}
.pay-info {
  @include fc(14px, #666);
  padding-bottom: 45px;
  em {
    color: #166fff;
  }
}
.btn-normal {
  bottom: 40px;
    &:hover{
    background: #1460db;
  }
}
.rechargeInput{
  border: 1px solid #ccc;
  padding: 6px 10px;
  box-sizing: border-box;
  width: 140px;
}
.pop-tips{
  background: #FFFFFF;
  border: 2px solid #166EFF;
  box-shadow: 0 6px 12px 0 rgba(188,188,188,0.65);
  width: 600px;
  position: fixed;
  left: 50%;
  margin-left: -300px;
  top: 30%;
  z-index: 9;
  h2{
    background: #F7F9FD;
    line-height: 50px;
    font-size: 25px;
    color: #166EFF;
    padding-left: 38px;
  }
  .con{
    padding: 20px 0 40px 0px;
    p{
      font-size: 22px;
      color: #000000;
      letter-spacing: 0;
      line-height: 40px;
      padding-left: 40px;
      &:nth-child(4){
        margin-bottom: 65px;
      }
      &:nth-child(5), &:nth-child(6){
        text-align: center;
        font-size: 20px;
        padding-left: 0;
      }
    }
  }
  .close{
    display: block;
    position: absolute;
    top: 5px;
    right: 5px;
    background: #EF3939;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 26px;
    color: #fff;
    font-size: 30px;
    cursor: pointer;
  }
}
.recharge-history{
  background: #F6F6F6;
  padding: 20px 20px 5px 20px;
  margin-top: -15px;
  h3{
    font-size: 20px;
    color: #222222;
    margin-bottom: 10px;
    font-weight: bold;
  }
  ul{
    li{
      font-size: 18px;
      color: #555555;
      text-align: center;
      height: 50px;
      line-height: 50px;
      &:nth-child(1) {
        border-bottom: 1px solid #DADADA;
        font-size: 16px;
      }
      &:last-child {
        border-top: 1px solid #DADADA;
        padding-top: 5px;
        span{
          &:nth-child(2) {
            float: right;
            text-align: right;
            margin-right: 30px;
          }
        }
      }
      >span{
        float: left;
        &:nth-child(1) {
          width: 120px;
        }
        &:nth-child(2) {
          width: 250px;
        }
        &:nth-child(3) {
          width: 170px;
        }
        &:nth-child(4) {
          width: 170px;
          margin-left: 10px;
        }
        &:nth-child(5) {
          width: 150px;
          text-align: right;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/OrderRechargePay.vue